// import React, { useState, useEffect } from "react";
// import {
//   Button,
//   Divider,
//   Grid,
//   TextField,
//   MenuItem,
//   Select,
//   InputLabel,
//   FormControl,
// } from "@mui/material";
// import patientService from "../../Services/patientService";
// import toast from "react-hot-toast";
// import { useNavigate, useParams } from "react-router-dom";
// import doctorService from "../../Services/doctorService";
// import dispenserService from "../../Services/dispenserService";
// import hrService from "../../Services/hrService";

// const AddEditHR = () => {
//   const [patientData, setPatientData] = useState({
//     name: "",
//     email: "",
//     password: "",
//   });

//   const [doctorData, setDoctorData] = useState([]);

//   const { id } = useParams();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (id) {
//       // Fetch patient data for editing
//       const fetchPatientData = async () => {
//         try {
//           const response = await patientService.fetchPatientById(id); // Use the fetchPatientById service method
//           setPatientData(response.patient); // Assuming response has a 'patient' object
//         } catch (error) {
//           toast.error("Error fetching patient data.");
//         }
//       };

//       fetchPatientData();
//     }
//   }, [id]);

//   useEffect(() => {
//     const getDoctors = async () => {
//       try {
//         const response = await doctorService.fetchAllDoctors();
//         console.log(response); // Log the response to confirm the structure
//         setDoctorData(response.doctors); // Access the patients array within response
//       } catch (error) {
//         toast.error("Error fetching Doctors");
//       }
//     };
//     getDoctors();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setPatientData({ ...patientData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (id) {
//         await hrService.update(patientData);
//         toast.success("User updated successfully!");
//       } else {
//         await hrService.register(patientData);
//         toast.success("User added successfully!");
//       }
//       navigate("/patients");
//     } catch (error) {
//       toast.error("Error saving patient.");
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="w-[90%] m-auto">
//       <h1 className="m-[30px] text-center font-[700] text-[20px]">
//         {id ? "Edit HR" : "Add HR"}
//       </h1>
//       <Divider />
//       <div>
//         <div className="mt-[20px] flex">
//           <div style={{ width: "50%" }}>
//             <TextField
//               label="Name"
//               variant="outlined"
//               fullWidth
//               name="name"
//               value={patientData.name}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "50%" }}>
//             <TextField
//               label="Email"
//               variant="outlined"
//               fullWidth
//               name="email"
//               value={patientData.email}
//               onChange={handleChange}
//               required
//             />
//           </div>
//         </div>

//         <div className="mt-[20px] flex">
//         <div style={{ width: "50%" }}>
//             <TextField
//               label="Password"
//               variant="outlined"
//               fullWidth
//               name="password"
//               type="password"
//               value={patientData.password}
//               onChange={handleChange}
//               required
//             />
//           </div>

//         </div>

//         <Grid container style={{ justifyContent: "center", marginTop: "30px" }}>
//           <Button
//             variant="contained"
//             type="submit"
//             color="primary"
//             size="large"
//             className="!bg-[#007fff] !text-white"
//             style={{ borderRadius: "10px" }}
//           >
//             Save and Continue
//           </Button>
//         </Grid>
//       </div>
//     </form>
//   );
// };

// export default AddEditHR;

import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import patientService from "../../Services/patientService";
import hrService from "../../Services/hrService";

const AddEditHR = () => {
  const [patientData, setPatientData] = useState({
    name: "",
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const fetchPatientData = async () => {
        try {
          const response = await patientService.fetchPatientById(id);
          setPatientData(response.patient);
        } catch (error) {
          toast.error("Error fetching HR data.");
        }
      };
      fetchPatientData();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPatientData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      if (id) {
        await hrService.update(patientData);
        toast.success("HR updated successfully!");
      } else {
        await hrService.register(patientData);
        toast.success("HR added successfully!");
      }
      navigate("/patients");
    } catch (error) {
      toast.error("Error saving HR.");
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    "w-full px-3 py-2 text-sm text-gray-800 bg-white border border-gray-200 rounded-lg placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 transition";

  const labelClass =
    "block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5";

  return (
    <div className="p-3 sm:p-6 font-sans">
      {/* ── Page Header ── */}
      <div className="mb-6">
        <p className="text-xs font-medium tracking-widest uppercase text-gray-500">
          {id ? "Edit HR" : "Add HR"}
        </p>
        <p className="text-xs text-gray-400 mt-0.5">
          {id
            ? "Update the HR account details below."
            : "Fill in the details to create a new HR account."}
        </p>
      </div>

      {/* ── Form Card ── */}
      <div className="border border-gray-200 rounded-xl overflow-hidden">
        {/* Card Header */}
        <div className="bg-[#215187] px-4 py-3">
          <p className="text-[12px] text-gray-100 font-medium uppercase tracking-wide">
            HR Information
          </p>
        </div>

        {/* Card Body */}
        <div className="bg-white px-4 py-5 sm:px-6 sm:py-6">
          <form onSubmit={handleSubmit}>
            {/* Row 1 — Name + Email */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <div>
                <label className={labelClass} htmlFor="name">
                  Name
                </label>
                <input
                  id="name"
                  type="text"
                  name="name"
                  placeholder="Full name"
                  value={patientData.name}
                  onChange={handleChange}
                  required
                  className={inputClass}
                />
              </div>
              <div>
                <label className={labelClass} htmlFor="email">
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  placeholder="email@example.com"
                  value={patientData.email}
                  onChange={handleChange}
                  required
                  className={inputClass}
                />
              </div>
            </div>

            {/* Row 2 — Password */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              <div>
                <label className={labelClass} htmlFor="password">
                  Password
                </label>
                <div className="relative">
                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder={
                      id ? "Leave blank to keep current" : "Enter password"
                    }
                    value={patientData.password}
                    onChange={handleChange}
                    required={!id}
                    className={`${inputClass} pr-10`}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword((v) => !v)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition"
                    tabIndex={-1}
                  >
                    {showPassword ? (
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M13.875 18.825A10.05 10.05 0 0 1 12 19c-5 0-9-4-9-7s4-7 9-7c1.06 0 2.08.176 3.025.505M15 12a3 3 0 0 1-3 3m6.364-6.364A9.956 9.956 0 0 1 21 12c0 3-4 7-9 7a9.95 9.95 0 0 1-2.875-.425M3 3l18 18"
                        />
                      </svg>
                    ) : (
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        />
                      </svg>
                    )}
                  </button>
                </div>
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-100 mb-5" />

            {/* Actions */}
            <div className="flex flex-col-reverse sm:flex-row items-center justify-center gap-3">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="w-full sm:w-auto px-5 py-3 text-[13px] font-medium text-gray-600 border border-gray-200 rounded-lg bg-white hover:bg-gray-50 transition focus:outline-none focus:ring-2 focus:ring-gray-100"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="w-full sm:w-auto px-6 py-3 text-[13px] font-medium text-white bg-[#215187] rounded-lg hover:bg-[#255A8C] transition focus:outline-none focus:ring-2 focus:ring-gray-300 disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                {loading && (
                  <svg
                    className="w-3.5 h-3.5 animate-spin"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 0 1 8-8v8z"
                    />
                  </svg>
                )}
                {loading ? "Saving..." : id ? "Update HR" : "Save and Continue"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddEditHR;
